import { render, staticRenderFns } from "./assign-label-modal.vue?vue&type=template&id=06171ab0&scoped=true&"
import script from "./assign-label-modal.vue?vue&type=script&lang=ts&"
export * from "./assign-label-modal.vue?vue&type=script&lang=ts&"
import style0 from "./assign-label-modal.vue?vue&type=style&index=0&id=06171ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06171ab0",
  null
  
)

export default component.exports